export enum ContentGeneratorEventEnum {
  CHANGE = 'CHANGE',
  TACTIC_CHANGE = 'TACTIC_CHANGE',
  ACTIVITY_CHANGE = 'ACTIVITY_CHANGE',
}
